module.exports = __webpack_public_path__ + "static/kz-aebe1ef9087c99b2fbb7fbb2b44bc792.svg";